<template>
    <b-nav-item-dropdown
    ref="item-dropdown" no-caret :text="menu.name" :class="['peekage-nav-item w-full', menu.name , {
            'only-device': menu.onlyDevice,
            'active': isActive
        }]"
    >
        <template #button-content>
            <div class="w-full">
                <div class="d-flex align-items-center justify-content-between p-x-20 w-full after" @click="toggleVisibility">
                    <span class="font nav-text text-color primary m-r-4">{{ menu.name }}</span>
                    <UIcon name="i-pkg-navigation-chevron-down" class="size-5 shrink-0 only-desktop text-[#141414]" />
                    <UIcon name="i-pkg-navigation-chevron-right" class="size-5 shrink-0 only-device text-[#141414]" />
                </div>
            </div>
        </template>

        <b-dropdown-text id="nav-item-style-1" class="p-0" @click.stop>
            <nav-item
                :menu-version="menu.version"
                :sub-menus="menu.sub" :menu-name="menu.name"
                @close-item="handleCloseItem"
                @handle-collapse="$emit('handle-collapse')"
            />
        </b-dropdown-text>
    </b-nav-item-dropdown>
</template>

<script>
import NavItem from '~/components/layout/header/nav-item';

export default {
    components: {
        NavItem,
    },
    props: {
        menu: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['handle-collapse'],
    data() {
        return {
            isActive: false,
        };
    },
    methods: {
        handleCloseItem() {
            if (this.$refs['item-dropdown']) {
                this.$refs['item-dropdown'].hide();
            }
            // Fallback cleanup for manual show
            if (this.$el) {
                const dropdownEl = this.$el.querySelector('.dropdown');
                const buttonEl = dropdownEl?.querySelector('button[aria-haspopup="menu"]');
                const menuEl = dropdownEl?.querySelector('.dropdown-menu');
                dropdownEl?.classList.remove('show');
                buttonEl?.setAttribute('aria-expanded', 'false');
                menuEl?.classList.remove('show');
                if (menuEl?.style) menuEl.style.display = '';
            }
            this.showAllMenus();
        },
        toggleVisibility() {
            if (!import.meta.client) return;
            
            if (window.innerWidth > 992) {
                return;
            }
            const allMenuItems = window.document.querySelectorAll('.peekage-nav-item');
            const currentItem = (this.$el && (this.$el.classList?.contains('peekage-nav-item') ? this.$el : this.$el.closest('.peekage-nav-item'))) || null;
            allMenuItems.forEach((item) => {
                const isCurrent = currentItem && item === currentItem;
                if (isCurrent) {
                    if (item.style) item.style.display = '';
                } else {
                    if (item.style) item.style.display = 'none';
                }
            });
            // Ensure the current dropdown opens
            try {
                if (this.$refs['item-dropdown'] && typeof this.$refs['item-dropdown'].show === 'function') {
                    this.$refs['item-dropdown'].show();
                } else if (this.$el) {
                    const dropdownEl = this.$el.querySelector('.dropdown');
                    const buttonEl = dropdownEl?.querySelector('button[aria-haspopup="menu"]');
                    const menuEl = dropdownEl?.querySelector('.dropdown-menu');
                    dropdownEl?.classList.add('show');
                    if (buttonEl) buttonEl.setAttribute('aria-expanded', 'true');
                    if (menuEl) {
                        menuEl.classList.add('show');
                        menuEl.style.display = 'block';
                    }
                }
            } catch (e) {
                // no-op
            }
        },
        showAllMenus() {
            if (!import.meta.client) return;
            window.document.querySelectorAll('.peekage-nav-item').forEach((item) => {
                if (item.style) item.style.display = '';
            });
        },
    },
};
</script>

<style lang="scss">
.dropdown {
    position: unset;
    &.Resources {
        position: relative;
    }
}
.b-dropdown-text{
    padding: 0;
    margin: 0;
}
/* Keep the dropdown label aligned with its trigger. */
.dropdown-item-text{
    padding: 0 !important;
    margin: 0;
}
    .peekage-nav-item {
        outline: none;
        min-height: 57px;
        min-width: 124px;
        border-bottom: 2px solid transparent;
        padding: 16px 0 16px 0;
        .after{
                ::after{
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-51%);
                    width: 90%;
                    height: 2px;
                    background-color: #F4F4F4;
                }
                :last-child{
                    ::after{
                        content: none;
                    }
                }

            }

        &.show {
            padding: 0;
            .nav-link {
                display: none;
            }
        }

        .nav-text {
            font-size: 18px;
            line-height: 24px;
            font-weight: 700;
            letter-spacing: -0.3px;
        }

        &.show, &.active {
            color: #FF4F66;
            .nav-link {
                color: #FF4F66 !important;
            }
            &::after {
                background-color: #FF4F66 !important;
            }
        }

        .dropdown {
            position: unset;
            .dropdown-toggle {
                padding: 0;
            }
            // &-item {
            //     border-radius: 8px;
            //     padding: 0;
            //     width: 100%;
            //     white-space: normal !important;
            // }

        }

        @media only screen and (min-width: 992px) {
            /* For desktop: */
            // position: static !important;
            padding: 8px 0 8px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 72px;
            border-bottom: transparent;
            border-bottom: 2px solid transparent;
            ::after{
                content: none;
            }
            &.show {
            .nav-link {
                display: block;
                outline: none;
            }
        }
            &:hover, &.show, &.active {
                border-bottom: 2px solid #FF4F66;
                .nav-link{
                    background-color: #FFF1F3;
                }
            }
            .nav-text {
                font-size: 16px;
                line-height: 20px;
                font-weight: 500;
                letter-spacing: -0.3px;
            }

            .dropdown {
                .dropdown-toggle {
                    padding: 8px;
                }
                &-menu {
                    margin: 0;
                    &.show {
                        display: flex;
                        transform: none !important;
                        top: 70px !important;
                        left: 0 !important;
                        right: auto !important;
                        border-radius: var(--Sizing-Space-500, 20px);
                        background: linear-gradient(180deg, #FFF1F3 30%, #FFF 100%), var(--Color-White, #FFF);
                        background: #FFF;
                        box-shadow: 0px 20px 32px 0px rgba(0, 0, 0, 0.12);
                        margin-top: 2px;

                    }
                }
            }
        }
    }
</style>
